import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import { getAtMentionsCapabilityData } from '../clients/getAtMentionsCapabilityData';
const getCapabilitiesDataQuery = registerQuery({
  fetcher: getAtMentionsCapabilityData,
  fieldName: 'getCapabilitiesData',
  args: ['inboxId']
});
export const useAtMentionCapabilityData = ({
  inboxId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(getCapabilitiesDataQuery, {
    variables: {
      inboxId: inboxId
    },
    skip: !inboxId
  });
  return useMemo(() => {
    var _data$getCapabilities;
    return {
      users: (data === null || data === void 0 || (_data$getCapabilities = data.getCapabilitiesData) === null || _data$getCapabilities === void 0 ? void 0 : _data$getCapabilities.users) || [],
      isLoading: loading,
      isError: !!error
    };
  }, [data, loading, error]);
};